import { useContext } from 'react';
import { ThemeContext } from '../provider/ThemeProvider';

const useTheme = () => {
    return useContext(ThemeContext)?.values;
};

export default useTheme;
